// jQuery.noConflict() を使用して $ を jQuery に戻す
jQuery.noConflict();
(function ($) {
	// ドキュメントが読み込まれた後に実行する関数
	$(document).ready(function () {
		var main = new MAIN();
		main.init();
	});

	function MAIN() {
		// SELECT ONCE
		var els = {
			window: $(window),
			document: $(document),
			body: $("body")
		};
		var loadImgNum = $('.topSlider img').length + $('.itemList img').length;
		var loadedImgNum = 0;
		var video = document.getElementById("player");
		var videoFlg = false;
		var movieTime = $(window).width() > 720 ? 1000 : 800;

		function init() {
			$("html, body").animate({ scrollTop: 0 }, 0).addClass("hidden");

			setTimeout(function () {
				$("html, body").animate({ scrollTop: 0 }, 0);
			}, 300);

			$('.topSlider img, .itemList img').each(function () {
				$(this).imagesLoaded(function () {
					loadedImgNum++;
				});
			});

			if (video.readyState === 4) {
				videoFlg = true;
			}

			var checkload = function () {
				var nowPercent = Math.ceil(100 * loadedImgNum / loadImgNum);

				if (nowPercent >= 100) {
					$("#wrap_all path, #wrap_all polygon, #wrap_all rect").addClass("animate");
					setTimeout(fadeOpening, 3000);
					setTimeout(fadeStr, 1300);
					setTimeout(fadeHidden, 3600);
				} else {
					setTimeout(checkload, 15);
				}
			};

			setTimeout(checkload, 100);
		}

		function fadeOpening() {
			$(".topSlider img").imagesLoaded(function () {
				$(".topSlider").slick({
					autoplay: true,
					autoplaySpeed: 3000,
					speed: 1000,
					arrows: false,
					dots: false,
					centerMode: false,
					centerPadding: '0px',
					pauseOnHover: false,
					fade: true,
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					draggable: true,
				});
			});

			$(".itemSlider").slick({
				autoplay: true,
				autoplaySpeed: 3000,
				speed: 1000,
				arrows: false,
				dots: false,
				centerMode: false,
				centerPadding: '0px',
				pauseOnHover: false,
				fade: true,
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: true,
			});

			$(".openingBox").delay(600).animate({
				opacity: 0
			}, {
				duration: 1000,
				easing: 'easeOutCubic',
				complete: function () {
					$(".openingBox").hide();
				}
			});
		}

		function fadeStr() {
			$("#miniStr").addClass("animate");
		}

		function fadeHidden() {
			$("html, body").removeClass("hidden");
		}

		return {
			init: init
		};
	}
})(jQuery);
